module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasCoords) ? _c('PageOuter', {
    attrs: {
      "fix-height": true
    }
  }, [(_vm.isMounted) ? _c('YandexMap', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "coords": _vm.coords,
      "zoom": "15"
    }
  }, _vm._l((_vm.markers), function(ref, index) {
    var address = ref.address;
    var coords = ref.coords;
    var balloon = ref.balloon;

    return _c('YmapMarker', {
      key: index,
      attrs: {
        "marker-id": index,
        "hint-content": address,
        "coords": coords,
        "balloon": balloon,
        "icon": {
          color: 'blue'
        },
        "marker-type": "placemark"
      }
    })
  }), 1) : _vm._e()], 1) : _c('center', [_c('b', [_vm._v("К СОЖАЛЕНИЮ, ПО ДАННОМУ ОРГАНИЗАТОРУ НЕ УКАЗАНЫ КООРДИНАТЫ.")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82c7c368","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/organizations/card/map/component.vue
// module id = baa242300cd7713605cb
// module chunks = 1